import { atom } from "jotai";

import {
  getContinuePurchaseCourses,
  getRecentlyViewedCourses,
} from "@/lib/utils";

export const coursePackagesAtom = atom([]);
export const courseCouponAtom = atom(null);
export const emiRequestModalAtom = atom(false);

export const userCourseDetailAtom = atom(null);

export const userCoursePurchasedAtom = atom((get) => {
  const userCourseDetail = get(userCourseDetailAtom);
  if (!userCourseDetail) return false;

  return userCourseDetail.purchased && userCourseDetail.validityLeftDays > 0;
});

export const continuePurchaseProductsAtom = atom(() =>
  getContinuePurchaseCourses()
);

export const recentlyViewedProductsAtom = atom(() =>
  getRecentlyViewedCourses()
);
